try{(function(){
var button=document.getElementById('amc-cookie-preferences');
if(!button||button.dataset.ready==='true')return;
button.dataset.ready='true';
button.addEventListener('click',function(){
if(window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function'){
window.privacyBanner.showPreferences();
return;
}
window.location.href=button.dataset.fallback||'/policies/privacy-policy';
});
})();}catch(error){console.error(error)}
try{(function(){
var heroIds={
'10x10-walk-in-mortuary-cooler':'9538819064110',
'4-body-upright-mortuary-cooler':'4481785430076',
'4-tier-side-loading-mortuary-rack':'10410836307',
'low-profile-powered-crematory-lift':'8022064791854'
};
function family(text){
text=(text||'').toLowerCase();
if(text.indexOf('turbo air')>-1)return 'TA';
if(/autopsy|pathology|grossing|anatomy|dissection/.test(text))return 'USPE';
if(text.indexOf('embalm')>-1||text.indexOf('table')>-1||text.indexOf('lift')>-1||text.indexOf('rack')>-1||text.indexOf(' cot ')>-1||text.indexOf('stretcher')>-1||text.indexOf('transport')>-1)return 'AME';
return 'AMC';
}
function numberFor(id){
id=String(id||'').split('').filter(function(ch){return ch>='0'&&ch<='9';}).join('');
if(!id)return '';
return String(parseInt(id.slice(-9),10));
}
function text(el,value){if(el&&el.textContent!==value)el.textContent=value;}
function decorateRow(row,title){
if(!row)return;
var label=row.querySelector('.amc-card-model__label, :scope > span');
var strong=row.querySelector('.amc-card-model__number, :scope > strong');
var prefix=family(title);
text(label,prefix+' item');
if(strong&&strong.textContent.indexOf('-')>0&&!isNaN(Number(strong.textContent.split('-').pop()))){
text(strong,prefix+strong.textContent.trim().replace(/^[A-Z]+/,''));
if(strong){var po=row.querySelector('.amc-card-model__po,.amc-cslider__po');row.setAttribute('aria-label',prefix+' item '+strong.textContent.trim()+(po?', '+po.textContent.trim():''));}
}
}
function decorate(root){
if(!root||root.nodeType!==1)return;
var rows=[];
if(root.matches&&root.matches('.amc-card-model,.amc-cslider__model'))rows.push(root);
if(root.querySelectorAll)rows=rows.concat(Array.prototype.slice.call(root.querySelectorAll('.amc-card-model,.amc-cslider__model')));
rows.forEach(function(row){
var card=row.closest('.card,.amc-cslider__card,article,li')||row.parentElement;
var heading=card&&card.querySelector('h2,h3,h4,.card__heading,.amc-cslider__title');
decorateRow(row,heading?heading.textContent:'');
});
var heroRows=[];
if(root.matches&&root.matches('.amc-hero__identity'))heroRows.push(root);
if(root.querySelectorAll)heroRows=heroRows.concat(Array.prototype.slice.call(root.querySelectorAll('.amc-hero__identity')));
heroRows.forEach(function(row){
var card=row.closest('.amc-hero__feature-copy,.amc-hero__feature,aside')||row.parentElement;
var link=card&&card.querySelector('a[href*="/products/"]');
if(!link)return;
var href=link.getAttribute('href')||'';var handle=(href.split('/products/')[1]||'').split('?')[0].split('#')[0].split('/')[0];var match=handle?[handle,handle]:null;
if(!match||!heroIds[match[1]])return;
var original=(row.querySelector('.amc-hero__po')||row.querySelector('strong'));
original=original?original.textContent.replace('Order / PO ','').replace('ORDER / PO ','').trim():'';
var prefix=family((card.textContent||'')+' '+match[1]);
var label=document.createElement('span');label.textContent=prefix+' item';
var item=document.createElement('strong');item.className='amc-hero__model';item.textContent=prefix+'-'+numberFor(heroIds[match[1]]);
var po=document.createElement('small');po.className='amc-hero__po';po.textContent='Order / PO '+original;
var bars=document.createElement('i');bars.setAttribute('aria-hidden','true');
row.replaceChildren(label,item,po,bars);
});
}
function setupProduct(root){
if(!root||root.dataset.amcIdentityReady==='true')return;
var sku=root.querySelector('.product__sku')||document.querySelector('.product__sku');
var id=root.getAttribute('data-product-id');
if(!sku||!id)return;
root.dataset.amcIdentityReady='true';
if(sku.querySelector('[data-amc-cooler-base-model]'))return;
var title=(root.querySelector('h1')||document.querySelector('h1'));
var prefix=family(title?title.textContent:'');
var lock=false;
function render(orderSku){
orderSku=(orderSku||'').replace('MODEL / ITEM ','').trim();
if(!orderSku)return;
lock=true;
var item=document.createElement('span');item.className='amc-product-item';item.dataset.productId=id;
var label=document.createElement('span');label.className='amc-product-item__label';label.textContent=prefix+' item';
var number=document.createElement('strong');number.textContent=prefix+'-'+numberFor(id);
var bars=document.createElement('i');bars.setAttribute('aria-hidden','true');
item.append(label,number,bars);
var order=document.createElement('span');order.className='amc-product-order';order.append(document.createTextNode('Order / PO '));
var orderStrong=document.createElement('strong');orderStrong.dataset.amcOrderSku='';orderStrong.textContent=orderSku;order.append(orderStrong);
sku.replaceChildren(item,order);
sku.setAttribute('aria-label',prefix+' item '+numberFor(id)+', order or PO reference '+orderSku);
lock=false;
}
var current=sku.querySelector('[data-amc-order-sku]');
render(current?current.textContent:sku.textContent);
new MutationObserver(function(){
if(lock)return;
var existing=sku.querySelector('[data-amc-order-sku]');
if(!existing)render(sku.textContent);
}).observe(sku,{childList:true,subtree:true,characterData:true});
}
function boot(root){
decorate(root);
var products=[];
if(root.matches&&root.matches('product-info[data-product-id]'))products.push(root);
if(root.querySelectorAll)products=products.concat(Array.prototype.slice.call(root.querySelectorAll('product-info[data-product-id]')));
products.forEach(setupProduct);
}
function start(){
boot(document.documentElement);
new MutationObserver(function(records){
records.forEach(function(record){record.addedNodes.forEach(function(node){if(node.nodeType===1)boot(node);});});
}).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();}catch(error){console.error(error)}
try{(function(){
var logos={
AMC:{src:'/cdn/shop/files/BOLD_AMC_LOGO.png?width=180',alt:'American Mortuary Coolers'},
AME:{src:'/cdn/shop/files/MAIN_AME_LOGO.png?width=180',alt:'American Mortuary Equipment'},
USPE:{src:'/cdn/shop/files/USP_logo_Main.png?width=180',alt:'U.S. Pathology Equipment'}
};
function titleFor(card){
var heading=card.querySelector('.card__heading,.amc-cslider__title,h3,h2');
return heading?heading.textContent.trim():'Product';
}
function familyFor(card,vendor){
var label=card.querySelector('.amc-card-model__label,.amc-cslider__model>span');
var code=label?label.textContent.trim().split(' ')[0].toUpperCase():'';
if(logos[code]||code==='TA')return code;
var value=(vendor?vendor.textContent:'').toLowerCase();
if(value.indexOf('pathology')>-1)return 'USPE';
if(value.indexOf('mortuary equipment')>-1)return 'AME';
if(value.indexOf('mortuary cooler')>-1)return 'AMC';
if(value.indexOf('turbo air')>-1)return 'TA';
return '';
}
function brand(card){
var vendor=card.querySelector('.product-vendor,.amc-cslider__vendor');
if(!vendor||vendor.dataset.amcBrandReady==='true')return;
vendor.dataset.amcBrandReady='true';
if(vendor.querySelector('img,svg'))return;
var original=vendor.textContent.trim();
var code=familyFor(card,vendor);
vendor.classList.add('amc-card-brand');
vendor.replaceChildren();
if(logos[code]){
var img=document.createElement('img');
img.className='amc-card-brand__logo';
img.src=logos[code].src;
img.alt=logos[code].alt;
img.width=180;
img.height=40;
img.loading='lazy';
img.decoding='async';
vendor.append(img);
vendor.setAttribute('aria-label',logos[code].alt);
}else{
var mark=document.createElement('span');
mark.className='amc-card-brand__code';
mark.textContent=code==='TA'?'TA · TURBO AIR':(code||original);
vendor.append(mark);
vendor.setAttribute('aria-label',original||code);
}
}
function details(card){
var productLink=card.querySelector('.card__heading a[href*="/products/"],.amc-cslider__title[href*="/products/"],a[href*="/products/"]');
if(!productLink)return;
var url=productLink.getAttribute('href');
var title=titleFor(card);
var buttons=Array.prototype.slice.call(card.querySelectorAll('button'));
buttons.forEach(function(button){
if(button.closest('product-form,modal-opener,.amc-card-option-modal'))return;
var value=((button.getAttribute('aria-label')||'')+' '+button.textContent).toLowerCase();
if(value.indexOf('add to cart')<0&&value.indexOf('quick view')<0&&value.indexOf('choose options')<0)return;
var link=document.createElement('a');
link.href=url;
link.className=(button.className||'')+' amc-card-details-link';
link.textContent='Choose options & details';
link.setAttribute('aria-label','Choose options & details — '+title);
button.replaceWith(link);
});
var actions=card.querySelectorAll('.amc-cslider__action');
actions.forEach(function(action){
if(action.closest('product-form,modal-opener,.amc-card-option-modal'))return;
action.textContent='Choose options & details';
action.setAttribute('aria-label','Choose options & details — '+title);
});
}
function balance(card){
var heading=card.querySelector('.card__heading a,.amc-cslider__title');
if(heading)heading.setAttribute('title',heading.textContent.trim());
brand(card);
details(card);
}
function scan(root){
if(!root||root.nodeType!==1)return;
var cards=[];
if(root.matches&&root.matches('.product-card-wrapper,.amc-cslider__card'))cards.push(root);
if(root.querySelectorAll)cards=cards.concat(Array.prototype.slice.call(root.querySelectorAll('.product-card-wrapper,.amc-cslider__card')));
cards.forEach(balance);
}
function start(){
scan(document.documentElement);
new MutationObserver(function(records){
records.forEach(function(record){
record.addedNodes.forEach(function(node){if(node.nodeType===1)scan(node);});
});
}).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();}catch(error){console.error(error)}
